document.addEventListener('AppstleSubscription:SubscriptionWidget:widgetInitialised', function(e) {
  const subscriptionbox = document.querySelector('[subscriptionbox]');
  const subscriptionBoxOneTime = document.querySelector('[subscriptionBoxOneTime]');
  if(subscriptionbox || subscriptionBoxOneTime){
    // let CancelWrapper = document.querySelector('.appstle_subscription_radio_wrapper');
    // if(CancelWrapper) {
    //   CancelWrapper.appendChild('<p class="cancel__text">Pause or cancel anytime.</p>');
    // }
    const subscriptionItem = subscriptionbox.querySelectorAll('[subscriptionItem]');
    if(subscriptionItem.length > 0){
      setTimeout(function(){
        const subscriptionWidget = document.querySelector('.appstle_subscription_radio_wrapper');
        const oneTimeWrapper = document.querySelector('.appstle_one_time_details_wrapper');
        if(subscriptionWidget){
          if(!subscriptionWidget.querySelector('subscriptionboxWrapper')){
            subscriptionWidget.insertAdjacentHTML('afterend',subscriptionbox.innerHTML);
          }
        }
        if(oneTimeWrapper){
          if(!oneTimeWrapper.querySelector('subscriptionboxWrapper')){
            oneTimeWrapper.insertAdjacentHTML('afterend',subscriptionBoxOneTime.innerHTML);
          }
        } else {
          console.log('No ONe TIme Found');
        }
      },200)
    }
  }
  const tooltipBox = document.querySelector('[tooltipBox]');
  if(tooltipBox){
    setTimeout(function(){
      const appstleTooltip = document.querySelector('.appstle_tooltip_wrapper_static');
      if(appstleTooltip){
        if(!appstleTooltip.querySelector('[tooltipBoxWrapper]')){
          appstleTooltip.insertAdjacentHTML('beforeend',tooltipBox.innerHTML);
        }
      }
      initializeTooltip();
    },200)
  }
})

function initializeTooltip(){
  const tooltip = document.querySelector('.tooltip');
  if(tooltip) {
      const rect = tooltip.getBoundingClientRect();
      if (rect.left < 0) {
          tooltip.style.left = '0';
          tooltip.style.transform = 'translateX(0)';
      } else if (rect.right > window.innerWidth) {
          tooltip.style.left = '100%';
          tooltip.style.transform = 'translateX(-100%)';
      } else {
          tooltip.style.left = '50%';
          tooltip.style.transform = 'translateX(-50%)';
      }
  }
}
initializeTooltip();

window.addEventListener('resize', () => {
   initializeTooltip();
});

document.addEventListener("DOMContentLoaded", function () {
    // Select all buttons with the attribute [data-tab-id]
    const tabButtons = document.querySelectorAll("[data-tab-id]");

    tabButtons.forEach(button => {
        button.addEventListener("click", function () {
            // Remove active class from all buttons
            tabButtons.forEach(btn => btn.classList.remove("nutrition__popup-tab--active"));

            // Add active class to the clicked button
            this.classList.add("nutrition__popup-tab--active");

            // Get the ID from the clicked button
            const tabId = this.getAttribute("data-tab-id");

            // Select all images with [data-tab-img] attribute
            const tabImages = document.querySelectorAll("[data-tab-img]");

            // Remove active class from all images
            tabImages.forEach(img => img.classList.remove("nutrition__popup-img--active"));

            // Find the image that matches the clicked button's ID and add the active class
            const activeImage = document.getElementById(tabId);
            if (activeImage) {
                activeImage.classList.add("nutrition__popup-img--active");
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    // Select all buttons with the attribute [data-popup-btn]
    const popupButtons = document.querySelectorAll("[data-popup-btn]");

    popupButtons.forEach(button => {
        button.addEventListener("click", function () {
            // Add class to the body
            document.body.classList.add("active__popup");
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
    // Select all buttons with the attribute [data-popup-btn]
    const popupCloseButtons = document.querySelectorAll("[data-popup-close]");

    popupCloseButtons.forEach(button => {
        button.addEventListener("click", function () {
            // Add class to the body
            document.body.classList.remove("active__popup");
        });
    });
});